export const BOOLEAN_OPTIONS = [
    { label: "Yes", value: true },
    { label: "No", value: false },
    { label: "Off", value: null }
  ];
